import events from '../../actions/event-names';
import { showError, showSuccess } from '../../utils'

const initialState = {
    isListFetchCompleted: false,
    isListFetched: false,
    rpeScaleList: [],
    isDetailsFetched: false,
    rpeScaleDetails: "",
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
 
    //   LIST
    case `${events.GET_RPE_SCALE_LIST}_PENDING`: {
        if(action.meta.page === 0) {
            state.rpeScaleList = [];
        }
        return {
            ...state,
            isListFetched: 'PENDING',
        };
    }
    case `${events.GET_RPE_SCALE_LIST}_FULFILLED`: {
        if(action.payload.data.length === 0) {
            state.isListFetchCompleted = true;
        }
        return {
            ...state,
            rpeScaleList: [...state.rpeScaleList, ...action.payload.data],
            isListFetched: 'FULFILLED',
        };
    }
    case `${events.GET_RPE_SCALE_LIST}_REJECTED`: {
        return {
            ...state,
            isListFetched: 'REJECTED',
        };
    }


    //   DETAILS
    case `${events.GET_RPE_SCALE_DETAILS}_PENDING`: {
        return {
            ...state,
            rpeScaleDetails: "",
            isDetailsFetched: 'PENDING',
        };
    }
    case `${events.GET_RPE_SCALE_DETAILS_BG}_FULFILLED`: 
    case `${events.GET_RPE_SCALE_DETAILS}_FULFILLED`: {
        return {
            ...state,
            rpeScaleDetails: action.payload.data,
            isDetailsFetched: 'FULFILLED',
        };
    }
    case `${events.GET_RPE_SCALE_DETAILS}_REJECTED`: {
        return {
            ...state,
            isDetailsFetched: 'REJECTED',
        };
    }


    //  DETAILS SAVE
    case `${events.SAVE_RPE_SCALE_TRANSLATIONS}_PENDING`:
    case `${events.SAVE_RPE_SCALE_DETAILS}_PENDING`: {
        return {
            ...state,
            isRpeScaleDetailsSaved: 'PENDING',
        };
    }
    case `${events.SAVE_RPE_SCALE_TRANSLATIONS}_FULFILLED`:
    case `${events.SAVE_RPE_SCALE_DETAILS}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            isRpeScaleDetailsSaved: 'FULFILLED',
        };
    }
    case `${events.SAVE_RPE_SCALE_TRANSLATIONS}_REJECTED`:
    case `${events.SAVE_RPE_SCALE_DETAILS}_REJECTED`: {
        return {
            ...state,
            isRpeScaleDetailsSaved: 'REJECTED',
        };
    }

    case `${events.ADD_NEW_RPE_SCALE}_PENDING`: {
        return {
            ...state,
            isNewRpeScaleAdded: 'PENDING',
        };
    }
    case `${events.ADD_NEW_RPE_SCALE}_FULFILLED`: {
        showSuccess("New RPE Scale added successfully")
        return {
            ...state,
            isNewRpeScaleAdded: 'FULFILLED',
        };
    }
    case `${events.ADD_NEW_RPE_SCALE}_REJECTED`: {
        return {
            ...state,
            isNewRpeScaleAdded: 'REJECTED',
        };
    }


    case `${events.DELETE_RPE_SCALE}_PENDING`: {
        return {
            ...state,
            isRpeCycleDeleted: 'PENDING',
        };
    }
    case `${events.DELETE_RPE_SCALE}_FULFILLED`: {
        showSuccess("RPE Cycle deleted successfully")
        return {
            ...state,
            isRpeCycleDeleted: 'FULFILLED',
        };
    }
    case `${events.DELETE_RPE_SCALE}_REJECTED`: {
        return {
            ...state,
            isAssessmentTestDeleted: 'REJECTED',
        };
    }
    
    default:
        return state;
    }
}
